/* ─── 기존 이미지 슬라이더 (freeMode) ─── */
function initRangercoreSliders() {
  document.querySelectorAll('[data-rangercore-image-slider]').forEach(function (el) {
    var slidesMobile = parseFloat(el.dataset.slidesMobile) || 1.2;
    var slidesDesktop = parseFloat(el.dataset.slidesDesktop) || 2.5;
    var slideGap = parseInt(el.dataset.slideGap, 10) || 0;
    var scrollbarEl = el.querySelector('.swiper-scrollbar');

    new Swiper(el, {
      slidesPerView: slidesMobile,
      spaceBetween: slideGap,
      threshold: 10,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumBounce: true,
      },
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        hide: false,
      },
      breakpoints: {
        750: {
          slidesPerView: slidesDesktop,
          spaceBetween: slideGap,
        },
      },
    });
  });
}

/* ─── 분할 슬라이더 (연속 흐름, 우→좌) ─── */
function initRangerCoreSplitSliders() {
  document.querySelectorAll('[data-rangercore-split-slider]').forEach(function (el) {
    var slides = el.querySelectorAll('.swiper-slide');
    if (slides.length < 2) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observer.unobserve(el);
          var speed = parseInt(el.dataset.slideSpeed, 10) || 4000;
          new Swiper(el, {
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 10,
            speed: speed,
            freeMode: true,
            autoplay: { delay: 0, disableOnInteraction: false },
            allowTouchMove: false,
          });
        }
      });
    }, { rootMargin: '200px' });

    observer.observe(el);
  });
}

/* ─── 토글 (텍스트 아코디언 애니메이션) ─── */
function initRangercoreToggles() {
  document.querySelectorAll('[data-rangercore-toggle]').forEach(function (details) {
    var content = details.querySelector('.campaign-rangercore__toggle-content');
    var summary = details.querySelector('summary');
    if (!content || !summary) return;

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (details.open) {
        content.style.gridTemplateRows = '0fr';
        content.addEventListener('transitionend', function handler() {
          details.removeAttribute('open');
          content.removeEventListener('transitionend', handler);
        }, { once: true });
      } else {
        details.setAttribute('open', '');
        requestAnimationFrame(function () {
          content.style.gridTemplateRows = '1fr';
        });
      }
    });
  });
}

/* ─── 초기화 ─── */
var _swiperRetry = 0;
function initAll() {
  if (typeof Swiper === 'undefined') {
    if (++_swiperRetry < 50) setTimeout(initAll, 100);
    return;
  }
  initRangercoreSliders();
  initRangerCoreSplitSliders();
  initRangercoreToggles();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
